module.exports = __webpack_public_path__ + "img/2023-01-09e_4.2231ae8a.jpg";